import { ArrowDownward } from '@material-ui/icons';
import React from 'react';
import PersonIcon from '@material-ui/icons/Person';

export const Topbardata=[
    {
        title:"perfil",
        icon:<PersonIcon/>,
        link:"/home/Perfil",
        down:<ArrowDownward/>
    },

];